// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"2155fefc","700":"c2257a5a"}[chunkId] + ".chunk.js";
};